import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

export const FAQ = () => {
  const { lang, t } = useLanguage();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#0A0A0A] py-28 md:py-40"
    >
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16"
        >
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-12 bg-[#C5A059]" />
            <span className="font-manrope text-xs font-semibold uppercase tracking-[0.22em] text-[#C5A059]">
              {t.faq.kicker}
            </span>
          </div>
          <h2 className="font-bebas text-4xl uppercase leading-none tracking-tight text-[#F5F5F5] sm:text-5xl lg:text-6xl">
            {t.faq.heading}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
        >
          <AccordionPrimitive.Root type="single" collapsible className="border-t border-[#2A2A2A]">
            {t.faq.items.map((item, i) => (
              <AccordionPrimitive.Item
                key={`${lang}-${i}`}
                value={`item-${i}`}
                className="border-b border-[#2A2A2A]"
              >
                <AccordionPrimitive.Trigger
                  data-testid={`faq-question-${i}`}
                  className="group flex w-full items-center justify-between gap-6 py-7 text-left"
                >
                  <span className="font-bebas text-xl uppercase tracking-wide text-[#F5F5F5] transition-colors duration-300 group-data-[state=open]:text-[#C5A059] md:text-2xl">
                    {item.q}
                  </span>
                  <Plus className="h-5 w-5 shrink-0 text-[#C5A059] transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </AccordionPrimitive.Trigger>
                <AccordionPrimitive.Content
                  data-testid={`faq-answer-${i}`}
                  className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
                >
                  <p className="max-w-2xl pb-7 font-manrope text-sm leading-relaxed text-[#8A9199] md:text-base">
                    {item.a}
                  </p>
                </AccordionPrimitive.Content>
              </AccordionPrimitive.Item>
            ))}
          </AccordionPrimitive.Root>
        </motion.div>
      </div>
    </section>
  );
};
